import { render, staticRenderFns } from "./EstudiosForm.vue?vue&type=template&id=76c97883&scoped=true&"
import script from "./EstudiosForm.vue?vue&type=script&lang=js&"
export * from "./EstudiosForm.vue?vue&type=script&lang=js&"
import style0 from "./EstudiosForm.vue?vue&type=style&index=0&id=76c97883&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c97883",
  null
  
)

export default component.exports